import { fetchEndpoint } from "../network";

/**
 * 用户中心
 */

export default {
  // 用户列表
  list(params) {
    return fetchEndpoint("/user/users", "GET", params);
  },
  // 修改头像
  avatarModify(params) {
    return fetchEndpoint(
      "/create-platform/user-center/avatar/modify",
      "POST",
      params
    );
  },

  // 昵称修改
  nicknameModify(params) {
    return fetchEndpoint(
      "/create-platform/user-center/nickname/modify",
      "POST",
      params
    );
  },

  // 密码修改
  passwordModify(params) {
    return fetchEndpoint(
      "/create-platform/user-center/password/modify",
      "POST",
      params
    );
  },

  // 发送短信验证吗
  sendMsg(params) {
    return fetchEndpoint(
      "/create-platform/user-center/sendMsg",
      "POST",
      params
    );
  },

  // 修改手机号
  phoneModify(params) {
    return fetchEndpoint(
      "/create-platform/user-center/phone/modify",
      "POST",
      params
    );
  },
};
